import { IconPropsType } from '..';

export const HeartFilledIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5618 10.8296L10.0017 17L3.42442 10.8189L3.41289 10.8081L3.11287 10.5227L3.12441 10.512C1.532 8.71363 1.63009 6.03227 3.42442 4.34162C5.21876 2.65096 8.09027 3.49779 10 5C11.9155 3.52472 14.7847 2.66173 16.5733 4.34162C18.3676 6.03227 18.4715 8.70825 16.8733 10.512L16.8848 10.5227L16.5848 10.8081L16.5618 10.8296Z"
        fill="currentColor"
      />
    </svg>
  );
};
